export const GROUPS_ITEM_PROPS = {
  compact: 'py-8',
  normal: 'border-b border-solid border-interactive-border py-16 px-8',
  'normal-small': 'border-b border-interactive-secondary-hover py-12',
};

export const GROUPS_PROPS = {
  compact: 'my-4 ps-12 pe-10',
  normal: 'rounded-8 px-8',
  'normal-small': 'px-12',
};
